/* eslint-disable */
import { useState, useEffect } from 'react';
import { supabase } from '../supabaseClient';
import { UserPlus, Edit2, Trash2, X, Check, ShieldCheck, Lock, RefreshCw, Mail } from 'lucide-react';

const C = {
  yellow:      '#F7EC71', yellowLight: '#FEFCE8',
  orange:      '#E4AC49', orangeLight: '#FDF3DC',
  green:       '#7EA594', greenLight:  '#EAF2EF',
  cream:       '#F7F6EF', charcoal:    '#2F3A42',
  navy:        '#445366', mid:         '#7A8A96',
  border:      '#D8DEE3', skyBlue:     '#BCD9E5',
  skyBlueLight:'#EAF4F8', skyText:     '#3A8FA3',
  white:       '#FFFFFF', red:         '#DC3545',
  redLight:    '#FFF0F0', amber:       '#E07B00',
  amberLight:  '#FFF3E0', purple:      '#7C3AED',
  purpleLight: '#F3EEFF',
  pink: '#F2B8CB', pinkLight: '#FDF0F5', pinkText: '#C4607A',
};

const VENUES = ['Box Jordaan', 'Box Plantage', 'Sassys', 'Prep Kitchen'];
const ROLES  = ['admin', 'manager', 'supervisor', 'advisor', 'bar', 'kitchen'];

const ROLE_META = {
  admin:      { bg: C.purpleLight, color: C.purple,   label: 'Admin'      },
  manager:    { bg: C.skyBlueLight,color: C.skyText,  label: 'Manager'    },
  supervisor: { bg: C.amberLight,  color: C.amber,    label: 'Supervisor' },
  advisor:    { bg: C.pinkLight,   color: C.pinkText, label: 'Advisor'    },
  bar:        { bg: C.orangeLight, color: C.orange,   label: 'Bar'        },
  kitchen:    { bg: C.greenLight,  color: C.green,    label: 'Kitchen'    },
};

const inp = {
  width: '100%', padding: '8px 10px',
  border: `1px solid ${C.border}`, borderRadius: '8px',
  fontSize: '13px', color: C.charcoal, background: C.white,
  outline: 'none', boxSizing: 'border-box',
};
const lbl = { fontSize: '12px', fontWeight: 600, color: C.charcoal, display: 'block', marginBottom: '4px' };

function RolePill({ role }) {
  const m = ROLE_META[role] || { bg: C.cream, color: C.mid, label: role };
  return (
    <span style={{ background: m.bg, color: m.color, padding: '2px 10px', borderRadius: '20px', fontSize: '11px', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.04em' }}>
      {m.label}
    </span>
  );
}

// ── Password Reset Modal ─────────────────────────────────────────────
function ResetPasswordModal({ user, onClose }) {
  const [sending, setSending] = useState(false);
  const [done,    setDone]    = useState(false);
  const [err,     setErr]     = useState('');

  async function handleSend() {
    setSending(true); setErr('');
    const { error } = await supabase.auth.resetPasswordForEmail(user.email, {
      redirectTo: 'https://box.lekkermate.nl/set-password',
    });
    if (error) { setErr('Failed to send: ' + error.message); setSending(false); return; }
    setDone(true); setSending(false);
  }

  return (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(44,58,66,0.55)', zIndex: 700, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '16px' }}
      onClick={onClose}>
      <div style={{ background: C.white, borderRadius: '16px', width: '100%', maxWidth: '400px', boxShadow: '0 24px 64px rgba(0,0,0,0.22)', overflow: 'hidden' }}
        onClick={e => e.stopPropagation()}>
        <div style={{ padding: '20px 24px', background: C.navy, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <div>
            <div style={{ fontWeight: 700, fontSize: '15px', color: C.white }}>Reset Password</div>
            <div style={{ fontSize: '12px', color: C.skyBlue, marginTop: '2px' }}>{user.name}</div>
          </div>
          <button onClick={onClose} style={{ background: 'rgba(255,255,255,0.15)', border: 'none', borderRadius: '8px', cursor: 'pointer', color: C.white, padding: '6px', display: 'flex' }}>
            <X size={18}/>
          </button>
        </div>
        <div style={{ padding: '24px' }}>
          {done ? (
            <div style={{ textAlign: 'center' }}>
              <div style={{ width: '48px', height: '48px', borderRadius: '50%', background: C.greenLight, display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 12px' }}>
                <Check size={24} color={C.green}/>
              </div>
              <div style={{ fontWeight: 700, fontSize: '15px', color: C.charcoal, marginBottom: '4px' }}>Reset email sent</div>
              <div style={{ fontSize: '13px', color: C.mid, marginBottom: '20px' }}>
                A password reset link has been sent to <strong>{user.email}</strong>.
              </div>
              <button onClick={onClose} style={{ width: '100%', padding: '10px', background: C.navy, color: C.white, border: 'none', borderRadius: '8px', cursor: 'pointer', fontWeight: 600, fontSize: '13px' }}>Done</button>
            </div>
          ) : (
            <>
              <p style={{ margin: '0 0 16px', fontSize: '13px', color: C.charcoal, lineHeight: 1.6 }}>
                This will send a password reset email to:
              </p>
              <div style={{ background: C.cream, borderRadius: '8px', padding: '10px 14px', marginBottom: '20px', fontSize: '13px', fontWeight: 600, color: C.navy }}>
                {user.email}
              </div>
              {err && <div style={{ fontSize: '12px', color: C.red, marginBottom: '12px', padding: '8px 12px', background: C.redLight, borderRadius: '8px' }}>{err}</div>}
              <div style={{ display: 'flex', gap: '10px' }}>
                <button onClick={handleSend} disabled={sending}
                  style={{ flex: 1, padding: '10px', background: C.navy, color: C.white, border: 'none', borderRadius: '8px', cursor: 'pointer', fontWeight: 600, fontSize: '13px', opacity: sending ? 0.7 : 1 }}>
                  {sending ? 'Sending…' : 'Send Reset Email'}
                </button>
                <button onClick={onClose} style={{ padding: '10px 16px', border: `1px solid ${C.border}`, borderRadius: '8px', background: C.white, cursor: 'pointer', fontSize: '13px', color: C.mid }}>Cancel</button>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
}

// ── User Modal (create / edit) ───────────────────────────────────────
function UserModal({ user, onClose, onSaved, currentUserId }) {
  const isEdit = !!user;
  const [form, setForm] = useState({
    name:   user?.name   || '',
    email:  user?.email  || '',
    role:   user?.role   || 'bar',
    venue:  user?.venue  || 'Box Jordaan',
    venues: user?.venues || [],
  });
  const [saving,   setSaving]   = useState(false);
  const [err,      setErr]      = useState('');
  const [invited,  setInvited]  = useState(false);

  async function handleSave() {
    if (!form.name.trim() || !form.email.trim()) { setErr('Name and email are required.'); return; }
    if (!isEdit && (form.role === 'manager' || form.role === 'advisor') && (form.venues || []).length === 0) { setErr('Select at least one venue for manager or advisor.'); return; }
    setSaving(true); setErr('');

    if (isEdit) {
      const { error } = await supabase.from('profiles')
        .update({ name: form.name.trim(), role: form.role, venue: form.venue, venues: form.venues })
        .eq('id', user.id);
      if (error) { setErr('Update failed: ' + error.message); setSaving(false); return; }
      onSaved({ ...user, name: form.name.trim(), role: form.role, venue: form.venue, venues: form.venues });
    } else {
      const { data, error } = await supabase.functions.invoke('admin-create-user', {
        body: {
          email:  form.email.trim().toLowerCase(),
          name:   form.name.trim(),
          role:   form.role,
          venue:  form.venue,
          venues: form.venues,
        },
      });
      if (error || data?.error) {
        setErr(data?.error || error?.message || 'Failed to create user. Check edge function logs.');
        setSaving(false);
        return;
      }
      if (data?.warning) {
        // User created but email failed — show warning state
        setInvited('warning');
        setSaving(false);
        // Still add to list
        if (data.profile) onSaved(data.profile);
        return;
      }
      setInvited(true);
      setSaving(false);
      if (data.profile) onSaved(data.profile);
      return;
    }
    setSaving(false);
  }

  return (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(44,58,66,0.55)', zIndex: 600, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '16px' }}
      onClick={onClose}>
      <div style={{ background: C.white, borderRadius: '16px', width: '100%', maxWidth: '480px', boxShadow: '0 24px 64px rgba(0,0,0,0.22)', overflow: 'hidden' }}
        onClick={e => e.stopPropagation()}>
        <div style={{ padding: '20px 24px', background: C.navy, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <div>
            <div style={{ fontWeight: 700, fontSize: '15px', color: C.white }}>{isEdit ? 'Edit User' : 'Create New User'}</div>
            <div style={{ fontSize: '12px', color: C.skyBlue, marginTop: '2px' }}>
              {isEdit ? `Editing ${user.name}` : 'They\'ll log in with email + password'}
            </div>
          </div>
          <button onClick={onClose} style={{ background: 'rgba(255,255,255,0.15)', border: 'none', borderRadius: '8px', cursor: 'pointer', color: C.white, padding: '6px', display: 'flex' }}><X size={18}/></button>
        </div>

        <div style={{ padding: '24px', display: 'flex', flexDirection: 'column', gap: '14px' }}>

          {/* Invite sent success state */}
          {invited === true && (
            <div style={{ textAlign: 'center', padding: '8px 0' }}>
              <div style={{ width: '48px', height: '48px', borderRadius: '50%', background: C.greenLight, display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 12px' }}>
                <Mail size={22} color={C.green}/>
              </div>
              <div style={{ fontWeight: 700, fontSize: '15px', color: C.charcoal, marginBottom: '4px' }}>Invite sent!</div>
              <div style={{ fontSize: '13px', color: C.mid, marginBottom: '20px' }}>{form.name} will receive an email to set their password.</div>
              <button onClick={onClose} style={{ width: '100%', padding: '10px', background: C.navy, color: C.white, border: 'none', borderRadius: '8px', cursor: 'pointer', fontWeight: 600, fontSize: '13px' }}>Done</button>
            </div>
          )}

          {/* Email failed warning state */}
          {invited === 'warning' && (
            <div style={{ textAlign: 'center', padding: '8px 0' }}>
              <div style={{ background: C.amberLight, border: `1px solid ${C.amber}44`, borderRadius: '10px', padding: '14px', marginBottom: '16px', fontSize: '13px', color: C.amber, textAlign: 'left' }}>
                ⚠️ User created but the invite email failed to send. Use "Reset Password" on their profile to manually set access.
              </div>
              <button onClick={onClose} style={{ width: '100%', padding: '10px', background: C.navy, color: C.white, border: 'none', borderRadius: '8px', cursor: 'pointer', fontWeight: 600, fontSize: '13px' }}>Got it</button>
            </div>
          )}

          {/* Normal form — hidden after invite sent */}
          {!invited && (<>
          {err && <div style={{ fontSize: '12px', color: C.red, padding: '10px 12px', background: C.redLight, borderRadius: '8px' }}>{err}</div>}

          <div>
            <label style={lbl}>Full Name *</label>
            <input value={form.name} onChange={e => setForm(p => ({ ...p, name: e.target.value }))}
              placeholder="Jan de Vries" style={inp} autoFocus/>
          </div>

          <div>
            <label style={lbl}>Email Address *</label>
            <input type="email" value={form.email} onChange={e => setForm(p => ({ ...p, email: e.target.value }))}
              placeholder="jan@example.com" style={{ ...inp, background: isEdit ? C.cream : C.white, color: isEdit ? C.mid : C.charcoal }}
              disabled={isEdit}/>
            {isEdit
              ? <div style={{ fontSize: '11px', color: C.mid, marginTop: '4px' }}>Email cannot be changed here — use Supabase dashboard if needed.</div>
              : <div style={{ fontSize: '11px', color: C.mid, marginTop: '4px' }}>An invite email will be sent to this address.</div>
            }
          </div>

          <div>
            <label style={lbl}>Role *</label>
            <div style={{ display: 'flex', gap: '6px', flexWrap: 'wrap' }}>
              {ROLES.map(r => {
                const m = ROLE_META[r];
                const active = form.role === r;
                return (
                  <button key={r} onClick={() => setForm(p => ({ ...p, role: r }))}
                    style={{ padding: '6px 14px', borderRadius: '20px', border: `1.5px solid ${active ? m.color : C.border}`, background: active ? m.bg : C.white, color: active ? m.color : C.mid, fontSize: '12px', fontWeight: active ? 700 : 500, cursor: 'pointer', transition: 'all 0.15s' }}>
                    {m.label}
                  </button>
                );
              })}
            </div>
            <div style={{ fontSize: '11px', color: C.mid, marginTop: '6px' }}>
              {form.role === 'admin'      && '⚠️ Full access to all pages and settings'}
              {form.role === 'manager'    && 'Access to ops + reports + products/settings. Multi-venue.'}
              {form.role === 'supervisor' && 'Ops + reports + checklists. Single venue. No admin tools.'}
              {form.role === 'advisor'    && 'View-only access to Results, Group and Governance. No audit trail.'}
              {form.role === 'bar'        && 'Bar staff — sees bar products only'}
              {form.role === 'kitchen'    && 'Kitchen staff — sees kitchen products only'}
            </div>
          </div>

          <div>
            <label style={lbl}>Venue{(form.role === 'manager' || form.role === 'advisor') ? 's (select all that apply)' : ''}</label>

            {(form.role === 'manager' || form.role === 'advisor') ? (
              // Multi-venue picker for managers
              <>
                <div style={{ display: 'flex', gap: '6px', flexWrap: 'wrap' }}>
                  {VENUES.filter(v => v !== 'Prep Kitchen').map(v => {
                    const selected = (form.venues || []).includes(v);
                    return (
                      <button key={v} onClick={() => {
                        const cur = form.venues || [];
                        setForm(p => ({ ...p, venues: selected ? cur.filter(x => x !== v) : [...cur, v] }));
                      }}
                        style={{ padding: '6px 12px', borderRadius: '20px', border: `1.5px solid ${selected ? C.skyText : C.border}`, background: selected ? C.skyBlueLight : C.white, color: selected ? C.skyText : C.mid, fontSize: '12px', fontWeight: selected ? 700 : 500, cursor: 'pointer', transition: 'all 0.15s' }}>
                        {v.replace('Box ', '')}
                      </button>
                    );
                  })}
                </div>
                {(form.venues || []).length === 0 && (
                  <div style={{ fontSize: '11px', color: C.red, marginTop: '4px' }}>Select at least one venue</div>
                )}
                <div style={{ fontSize: '11px', color: C.mid, marginTop: '6px' }}>{form.role === 'manager' ? 'Manager' : 'Advisor'} can switch between their assigned venues when placing orders.</div>
              </>
            ) : (
              // Single venue picker for all other roles
              <>
                <div style={{ display: 'flex', gap: '6px', flexWrap: 'wrap' }}>
                  {VENUES.map(v => (
                    <button key={v} onClick={() => setForm(p => ({ ...p, venue: v }))}
                      style={{ padding: '6px 12px', borderRadius: '20px', border: `1.5px solid ${form.venue === v ? C.navy : C.border}`, background: form.venue === v ? C.navy : C.white, color: form.venue === v ? C.white : C.mid, fontSize: '12px', fontWeight: form.venue === v ? 700 : 500, cursor: 'pointer', transition: 'all 0.15s' }}>
                      {v.replace('Box ', '')}
                    </button>
                  ))}
                </div>
                {(form.role === 'admin') && (
                  <div style={{ fontSize: '11px', color: C.mid, marginTop: '6px' }}>Admin can access all venues regardless of this setting.</div>
                )}
              </>
            )}
          </div>

          <div style={{ display: 'flex', gap: '10px', paddingTop: '4px' }}>
            <button onClick={handleSave} disabled={saving || !form.name.trim() || !form.email.trim() || ((form.role === 'manager' || form.role === 'advisor') && (form.venues || []).length === 0)}
              style={{ flex: 1, padding: '10px', background: C.navy, color: C.white, border: 'none', borderRadius: '8px', cursor: 'pointer', fontWeight: 600, fontSize: '13px', opacity: saving ? 0.7 : 1 }}>
              {saving ? (isEdit ? 'Saving…' : 'Sending invite…') : isEdit ? 'Save Changes' : 'Send Invite'}
            </button>
            <button onClick={onClose} style={{ padding: '10px 16px', border: `1px solid ${C.border}`, borderRadius: '8px', background: C.white, cursor: 'pointer', fontSize: '13px', color: C.mid }}>Cancel</button>
          </div>
          </>)}
        </div>
      </div>
    </div>
  );
}

// ── Delete Confirm ───────────────────────────────────────────────────
function DeleteConfirm({ user, onClose, onConfirm }) {
  const [deleting, setDeleting] = useState(false);
  async function go() {
    setDeleting(true);
    await onConfirm(user);
    setDeleting(false);
  }
  return (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(44,58,66,0.5)', zIndex: 700, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '16px' }}
      onClick={onClose}>
      <div style={{ background: C.white, borderRadius: '14px', padding: '24px', width: '360px', maxWidth: '100%', boxShadow: '0 8px 32px rgba(0,0,0,0.18)' }}
        onClick={e => e.stopPropagation()}>
        <h3 style={{ margin: '0 0 10px', fontSize: '15px', fontWeight: 700, color: C.charcoal }}>Delete User</h3>
        <p style={{ fontSize: '13px', color: C.mid, marginBottom: '8px' }}>
          Remove <strong style={{ color: C.charcoal }}>{user.name}</strong>? This will delete their profile but their Supabase Auth account will remain — remove that separately if needed.
        </p>
        <p style={{ fontSize: '12px', color: C.red, marginBottom: '20px', padding: '8px 12px', background: C.redLight, borderRadius: '6px' }}>This cannot be undone.</p>
        <div style={{ display: 'flex', gap: '10px', justifyContent: 'flex-end' }}>
          <button onClick={onClose} style={{ padding: '8px 16px', border: `1px solid ${C.border}`, borderRadius: '8px', background: C.white, cursor: 'pointer', fontSize: '13px', color: C.mid, fontWeight: 500 }}>Cancel</button>
          <button onClick={go} disabled={deleting} style={{ padding: '8px 16px', background: C.red, color: C.white, border: 'none', borderRadius: '8px', cursor: 'pointer', fontSize: '13px', fontWeight: 600 }}>
            {deleting ? 'Deleting…' : 'Delete'}
          </button>
        </div>
      </div>
    </div>
  );
}

// ── User Row card ────────────────────────────────────────────────────
function UserRow({ user, onEdit, onDelete, onResetPw, isSelf }) {
  const initials = user.name?.split(' ').map(n => n[0]).join('').toUpperCase().slice(0, 2) || '?';
  const m = ROLE_META[user.role] || { bg: C.cream, color: C.mid };

  return (
    <div style={{ background: C.white, border: `1px solid ${C.border}`, borderRadius: '10px', padding: '14px 16px', display: 'flex', alignItems: 'center', gap: '14px', flexWrap: 'wrap', transition: 'box-shadow 0.15s' }}
      onMouseEnter={e => e.currentTarget.style.boxShadow = '0 2px 8px rgba(0,0,0,0.08)'}
      onMouseLeave={e => e.currentTarget.style.boxShadow = 'none'}>
      {/* Avatar */}
      <div style={{ width: '40px', height: '40px', borderRadius: '50%', background: m.bg, display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 700, fontSize: '14px', color: m.color, flexShrink: 0, border: `1px solid ${m.color}22` }}>
        {initials}
      </div>

      {/* Info */}
      <div style={{ flex: 1, minWidth: '140px' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap' }}>
          <span style={{ fontWeight: 700, fontSize: '14px', color: C.charcoal }}>{user.name}</span>
          {isSelf && <span style={{ fontSize: '10px', fontWeight: 700, background: C.yellowLight, color: C.charcoal, padding: '1px 7px', borderRadius: '20px', border: `1px solid ${C.yellow}` }}>YOU</span>}
        </div>
        <div style={{ fontSize: '12px', color: C.mid, marginTop: '2px' }}>{user.email}</div>
      </div>

      {/* Role + Venue */}
      <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap' }}>
        <RolePill role={user.role}/>
        <span style={{ fontSize: '12px', color: C.mid }}>
          {(user.role === 'manager' || user.role === 'advisor')
            ? (user.venues && user.venues.length > 0 ? user.venues.map(v => v.replace('Box ','')).join(' · ') : '—')
            : (user.venue || '—')}
        </span>
      </div>

      {/* Actions */}
      <div style={{ display: 'flex', gap: '6px', flexShrink: 0 }}>
        <button onClick={() => onResetPw(user)} title="Reset password"
          style={{ padding: '6px 10px', border: `1px solid ${C.border}`, borderRadius: '7px', background: C.white, cursor: 'pointer', color: C.mid, display: 'flex', alignItems: 'center', gap: '4px', fontSize: '12px', fontWeight: 500 }}>
          <Lock size={12}/> Password
        </button>
        <button onClick={() => onEdit(user)} title="Edit user"
          style={{ padding: '6px 10px', border: `1px solid ${C.border}`, borderRadius: '7px', background: C.white, cursor: 'pointer', color: C.charcoal, display: 'flex', alignItems: 'center', gap: '4px', fontSize: '12px', fontWeight: 500 }}>
          <Edit2 size={12}/> Edit
        </button>
        {!isSelf && (
          <button onClick={() => onDelete(user)} title="Delete user"
            style={{ padding: '6px 10px', border: `1px solid ${C.red}44`, borderRadius: '7px', background: C.redLight, cursor: 'pointer', color: C.red, display: 'flex', alignItems: 'center', gap: '4px', fontSize: '12px', fontWeight: 500 }}>
            <Trash2 size={12}/>
          </button>
        )}
      </div>
    </div>
  );
}

// ── Main ─────────────────────────────────────────────────────────────
export default function UserManagement({ currentUser }) {
  const [users,      setUsers]      = useState([]);
  const [loading,    setLoading]    = useState(true);
  const [search,     setSearch]     = useState('');
  const [roleFilter, setRoleFilter] = useState('All');

  const [showCreate,   setShowCreate]   = useState(false);
  const [editUser,     setEditUser]     = useState(null);
  const [deleteUser,   setDeleteUser]   = useState(null);
  const [resetPwUser,  setResetPwUser]  = useState(null);

  useEffect(() => { loadUsers(); }, []);

  async function loadUsers() {
    setLoading(true);
    const { data, error } = await supabase.from('profiles').select('*').order('name');
    if (!error && data) setUsers(data);
    setLoading(false);
  }

  async function handleDelete(user) {
    const { data, error } = await supabase.functions.invoke('admin-delete-user', {
      body: { userId: user.id },
    });
    if (error) {
      alert('Delete failed: ' + error.message);
      setDeleteUser(null);
      return;
    }
    setUsers(p => p.filter(u => u.id !== user.id));
    setDeleteUser(null);
  }

  function handleSaved(profile) {
    setUsers(prev => {
      const exists = prev.find(u => u.id === profile.id);
      return exists
        ? prev.map(u => u.id === profile.id ? profile : u)
        : [...prev, profile].sort((a, b) => a.name.localeCompare(b.name));
    });
    setShowCreate(false);
    setEditUser(null);
  }

  const roleCounts = ROLES.reduce((acc, r) => {
    acc[r] = users.filter(u => u.role === r).length;
    return acc;
  }, {});

  const filtered = users.filter(u => {
    if (roleFilter !== 'All' && u.role !== roleFilter) return false;
    if (search && !u.name.toLowerCase().includes(search.toLowerCase()) && !u.email?.toLowerCase().includes(search.toLowerCase())) return false;
    return true;
  });

  return (
    <div style={{ padding: '24px', maxWidth: '900px', margin: '0 auto' }}>

      {/* Modals */}
      {(showCreate || editUser) && (
        <UserModal
          user={editUser}
          onClose={() => { setShowCreate(false); setEditUser(null); }}
          onSaved={handleSaved}
          currentUserId={currentUser.id}
        />
      )}
      {deleteUser && (
        <DeleteConfirm user={deleteUser} onClose={() => setDeleteUser(null)} onConfirm={handleDelete}/>
      )}
      {resetPwUser && (
        <ResetPasswordModal user={resetPwUser} onClose={() => setResetPwUser(null)}/>
      )}

      {/* Header */}
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '24px', flexWrap: 'wrap', gap: '12px' }}>
        <div>
          <h2 style={{ margin: '0 0 4px', fontSize: '22px', fontWeight: 700, color: C.charcoal }}>User Management</h2>
          <p style={{ margin: 0, fontSize: '13px', color: C.mid }}>{users.length} user{users.length !== 1 ? 's' : ''} · admin only</p>
        </div>
        <button onClick={() => setShowCreate(true)}
          style={{ display: 'flex', alignItems: 'center', gap: '6px', padding: '9px 16px', background: C.navy, color: C.white, border: 'none', borderRadius: '8px', cursor: 'pointer', fontWeight: 600, fontSize: '13px' }}>
          <UserPlus size={14}/> Add User
        </button>
      </div>

      {/* Stats row */}
      <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap', marginBottom: '20px' }}>
        {[{ key: 'All', label: 'All', count: users.length, bg: C.navy, color: C.white },
          ...ROLES.map(r => ({ key: r, label: ROLE_META[r].label, count: roleCounts[r] || 0, bg: ROLE_META[r].bg, color: ROLE_META[r].color }))
        ].map(s => (
          <button key={s.key} onClick={() => setRoleFilter(s.key)}
            style={{ flex: '1 1 80px', padding: '10px 14px', borderRadius: '10px', border: `1.5px solid ${roleFilter === s.key ? s.color : C.border}`, background: roleFilter === s.key ? s.bg : C.white, cursor: 'pointer', textAlign: 'center', transition: 'all 0.15s' }}>
            <div style={{ fontSize: '20px', fontWeight: 700, color: roleFilter === s.key ? s.color : C.charcoal }}>{s.count}</div>
            <div style={{ fontSize: '11px', color: roleFilter === s.key ? s.color : C.mid, fontWeight: 600 }}>{s.label}</div>
          </button>
        ))}
      </div>

      {/* Search */}
      <div style={{ marginBottom: '16px' }}>
        <input value={search} onChange={e => setSearch(e.target.value)}
          placeholder="Search name or email…"
          style={{ ...inp, padding: '9px 14px', borderRadius: '20px', width: '260px' }}/>
      </div>

      {/* Info notice */}
      <div style={{ background: C.skyBlueLight, border: `1px solid ${C.skyBlue}`, borderRadius: '10px', padding: '12px 16px', marginBottom: '20px', fontSize: '12px', color: C.skyText, display: 'flex', alignItems: 'flex-start', gap: '8px' }}>
        <ShieldCheck size={16} style={{ flexShrink: 0, marginTop: '1px' }}/>
        <div>
          New users receive an <strong>email invite</strong> to set their own password. Password resets are handled via the <strong>Reset Password</strong> button or "Forgot password?" at login.
        </div>
      </div>

      {/* User list */}
      {loading ? (
        <div style={{ padding: '40px', textAlign: 'center', color: C.mid }}>Loading users…</div>
      ) : filtered.length === 0 ? (
        <div style={{ background: C.white, borderRadius: '10px', border: `1px solid ${C.border}`, padding: '40px', textAlign: 'center', color: C.mid }}>
          {search || roleFilter !== 'All' ? 'No users match this filter' : 'No users yet'}
        </div>
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
          {filtered.map(u => (
            <UserRow
              key={u.id}
              user={u}
              onEdit={setEditUser}
              onDelete={setDeleteUser}
              onResetPw={setResetPwUser}
              isSelf={u.id === currentUser.id}
            />
          ))}
        </div>
      )}



    </div>
  );
}